import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';
import { store } from '../../../common/redux/configure-store';
import { IHardwareInterventionInfo, IInterventionInfo } from '../../interfaces/IIntervention';
export interface IInterventionLookupResult {
  interventionInfo?: IInterventionInfo[];
  hardwareInterventions?: IHardwareInterventionInfo[];
}

export const interventionLookup = async (brmInput?: any): Promise<IInterventionLookupResult> => {
  const cartId = store.getState().transaction.transactionId || '';
  const axiosConfig: AxiosRequestConfig = {
    url: '/transaction-management/intervention',
    params: { cartId },
    method: 'POST',
    data: brmInput,
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };
  return emeraldRequest<IInterventionLookupResult>(emeraldRequestParams);
};

export const interventionDelete = async (
  interventionId: string,
  restriction: any,
): Promise<void> => {
  const cartId = store.getState().transaction.transactionId || '';
  const axiosConfig: AxiosRequestConfig = {
    url: '/transaction-management/delete-intervention',
    params: { cartId },
    method: 'DELETE',
    data: {
      interventionType: 'InterventionInfo',
      interventionId,
      restriction,
    },
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };
  return emeraldRequest(emeraldRequestParams);
};
